/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthSafetyQuestionFormDto } from '../../models/health-safety-question-form-dto';
import { HealthSafetyQuestionsAndCategoriesDto } from '../../models/health-safety-questions-and-categories-dto';

export interface UpdateHealthSafetyOrganization$Params {

/**
 * The customer id
 */
  customerId: number;
      body: Array<HealthSafetyQuestionFormDto>
}

export function updateHealthSafetyOrganization(http: HttpClient, rootUrl: string, params: UpdateHealthSafetyOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<HealthSafetyQuestionsAndCategoriesDto>> {
  const rb = new RequestBuilder(rootUrl, updateHealthSafetyOrganization.PATH, 'patch');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HealthSafetyQuestionsAndCategoriesDto>;
    })
  );
}

updateHealthSafetyOrganization.PATH = '/customers/{customerId}/health-safety-organization';
